module.exports = __webpack_public_path__ + "static/media/PosDirecto-vertical.1049d524.png";